$(document).ready(function(){
    $(document).on('click', 'a.grid', function(e){
        e.preventDefault();
        $('.outside-grid').addClass('grid');
        $('.grid-nav').addClass('grid');
        $(this).addClass('active');
        $('a.list').removeClass('active');

    });
    $(document).on('click', 'a.list', function(e){
        e.preventDefault();
        $('.outside-grid').removeClass('grid');
        $('.grid-nav').removeClass('grid');
        $(this).addClass('active');
        $('a.grid').removeClass('active');
    });

});